import { render, staticRenderFns } from "./TheProjects.vue?vue&type=template&id=66aacd4e&scoped=true&"
import script from "./TheProjects.vue?vue&type=script&lang=js&"
export * from "./TheProjects.vue?vue&type=script&lang=js&"
import style0 from "./TheProjects.vue?vue&type=style&index=0&id=66aacd4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aacd4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
